import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getFocusedViewFilter from 'mini-mail-list-store/lib/utils/getFocusedViewFilter';
import getItem from 'mini-localstorage/lib/utils/getItem';
import isFocusedInboxEnabled from 'mini-mail-focused-inbox-config/lib/isFocusedInboxEnabled';
import setItem from 'mini-localstorage/lib/utils/setItem';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { isNullOrUndefined } from 'mini-common-utils/lib/utils/isNullOrUndefined';

const DYNAMIC_AD_POSITION = 'dynamicAdPosition';

let dynamicAdPosition: number;

/**
 * This util returns the index of Native Ad in Mail List according to the feature flag.
 */
export const getAdPlacementIndex = () => {
    if (!isFocusedInboxEnabled()) {
        // for experiment in lite primary
        if (isMiniHostAppFeatureEnabled('adsInLitePrimary')) {
            // TODO: Remove this code once the experiment is over
            if (isMiniFeatureEnabled('lite-PrimaryAndCustomInboxAds-1stPosition-treatment')) {
                return 0;
            }

            if (isMiniFeatureEnabled('lite-PrimaryAndCustomInboxAds-2ndPosition-treatment')) {
                return 1;
            }

            if (isMiniFeatureEnabled('lite-PrimaryAndCustomInboxAds-3rdPosition-treatment')) {
                return 2;
            }
        } else {
            if (isMiniFeatureEnabled('miniAE-MultipleAdInPrimary-3rdPosition-treatment')) {
                return 2;
            }

            if (isMiniFeatureEnabled('miniAE-MultipleAdInPrimary-4thPosition-treatment')) {
                return 3;
            }

            if (isMiniFeatureEnabled('miniAE-MultipleAdInPrimary-5thPosition-treatment')) {
                return 4;
            }
        }
    } else if (getFocusedViewFilter() === 1) {
        if (isMiniFeatureEnabled('miniAE-MultipleAdInOther-3rdPosition-treatment')) {
            return 2;
        }

        if (isMiniFeatureEnabled('miniAE-MultipleAdInOther-4thPosition-treatment')) {
            return 3;
        }

        if (isMiniFeatureEnabled('miniAE-MultipleAdInOther-5thPosition-treatment')) {
            return 4;
        }

        // Dynamic Ad Positioning in other inbox in mini
        // This feature flag is used to test the dynamic ad positioning in the mail list.
        // store the position in local storage and use it to show the ad in the mail list.
        // The position will change every time the user refreshes.
        if (isMiniHostAppFeatureEnabled('otherInboxDynamicAds')) {
            if (!isNullOrUndefined(dynamicAdPosition)) return dynamicAdPosition;

            if (isMiniFeatureEnabled('miniAE-DynamicAdInOther-1-2-Position-treatment')) {
                dynamicAdPosition = getItem(DYNAMIC_AD_POSITION) || 0;
                setItem(DYNAMIC_AD_POSITION, dynamicAdPosition === 0 ? 1 : 0);
                return dynamicAdPosition;
            }

            if (isMiniFeatureEnabled('miniAE-DynamicAdInOther-1-3-Position-treatment')) {
                dynamicAdPosition = getItem(DYNAMIC_AD_POSITION) || 0;
                setItem(DYNAMIC_AD_POSITION, dynamicAdPosition === 0 ? 2 : 0);
                return dynamicAdPosition;
            }

            if (isMiniFeatureEnabled('miniAE-DynamicAdInOther-1-2-3-Position-treatment')) {
                dynamicAdPosition = getItem(DYNAMIC_AD_POSITION) || 0;
                setItem(
                    DYNAMIC_AD_POSITION,
                    dynamicAdPosition === 0 ? 1 : dynamicAdPosition === 1 ? 2 : 0
                );
                return dynamicAdPosition;
            }
        }
    } else {
        if (isMiniHostAppFeatureEnabled('adsInLitePrimary')) {
            // TODO: Remove this code once the experiment is over
            // for experiment in lite custom inbox
            if (isMiniFeatureEnabled('lite-PrimaryAndCustomInboxAds-1stPosition-treatment')) {
                return 0;
            }

            if (isMiniFeatureEnabled('lite-PrimaryAndCustomInboxAds-2ndPosition-treatment')) {
                return 1;
            }

            if (isMiniFeatureEnabled('lite-PrimaryAndCustomInboxAds-3rdPosition-treatment')) {
                return 2;
            }
        } else {
            if (isMiniFeatureEnabled('miniAE-FloatingAd-3rdPosition')) {
                return 2;
            }
        }
    }

    return 0;
};
